import { nftStakingContract } from "../config/main2.config";

export const getAllGroupRate = ()=>{
    return new Promise(async(resolve,reject)=>{
        const allPriceData = [nftStakingContract.XStakingRate(), nftStakingContract.xStakingCoinRate(), nftStakingContract.batXStakingRate(), nftStakingContract.batXStakingCoinRate(), nftStakingContract.captainXStakingRate(), nftStakingContract.captainXStakingCoinRate(), ]
        try{
            const allNFTRateData = await Promise.all(allPriceData)
            const allNFTRatesInNumber = allNFTRateData.map(rate=>parseInt(rate.toString()) / Math.pow(10, 18) )
            const nftRateObject = {
                "5" : {
                    "bnb" : allNFTRatesInNumber[0],
                    "token" : allNFTRatesInNumber[1]
                },
                "4" : {
                    "bnb" : allNFTRatesInNumber[2],
                    "token" : allNFTRatesInNumber[3]
                },
                "3" : {
                    "bnb" : allNFTRatesInNumber[4],
                    "token" : allNFTRatesInNumber[5]
                },
                
            }
            console.log(nftRateObject)
            resolve(nftRateObject)
        }
        catch(e){
            console.log(e)
        }
        
    })
}

export const getStakingDays = ()=>{
    return new Promise(async(resolve,reject)=>{
        const stakingDays = await nftStakingContract.mininumStakingDays()
        resolve(stakingDays)
    })
}